import Header from '../Header';

export default function About({ avatar }) {
  return (
    <div className='container'>
      <h1>About</h1>
      <img className='avatar circle' src={avatar}></img>
      <p>Hello,</p>
      <p>
        I study Engineering Science at OSU Cascades – focusing on the design and
        interaction of electrical and mechanical systems. Formerly, I was a
        senior marketing and product creative for global brands like Strava and
        AllTrails.
      </p>
      <p>
        Get in touch at:{' '}
        <a href='mailto:duboisch@oregonstate.edu'> duboisch@oregonstate.edu</a>
      </p>
    </div>
  );
}
